import axios from 'axios';
import axiosInstanceCustom from './interceptor';


import { getUserData } from "../utils";

import {
  ADMIN_ACTIVE_CASES_ENDPOINT,
  ADMIN_COMPLETED_CASES_ENDPOINT,
  ADMIN_CREATE_USER_ENDPOINT,
  ADMIN_GET_USERS_ENDPOINT,
  ADMIN_MANAGERS_LIST_ENDPOINT,
  ADMIN_PENDING_CASES_ENDPOINT,
  ADMIN_ROLES_LIST_ENPOINT,
  ADMIN_UPDATE_AGENTS,
  ADMIN_UPDATE_USER_STATUS_ENDPOINT,
  ADMIN_TRANSFER_TO_LEGAL,
  ADMIN_CASE_DETAILS_ENDPOINT,
  FETCH_MANDATORY_FIELD_ENDPOINT,
  UPDATE_MANDATORY_FIELD_ENDPOINT,
  CREATE_CLIENT_ENDPOINT,
  FETCH_PHONEBOOKS,
  FETCH_SAMPLE_PHONEBOOK,
  POST_CREATE_PHONEBOOK,
  ADMIN_LENDERS_LIST_ENDPOINT,
  UPDATE_LENDER_ENDPOINT,
  FETCH_MANDATORY_FIELD_Test,
  PRE_INTERVENTION_SUMMARY,
  FETCH_SAMPLE_PREINTERVENTION,
  PRE_INTERVENTION_TABLE,
} from "../constants/endpoints";

type UpdateUserDetailsBodyTypes = {
  firstName: string | "";
  lastName: string | "";
  email: string | "";
  realmRoles: string[];
  mobileNo: string | number;
};

type CasesBodyType = {
  dpdStatus: string;
  endDate: string;
  maxDueAmount: string;
  maxLoanAmount: string;
  minDueAmount: string;
  minLoanAmount: string;
  nbfc: string;
  page: number;
  size: number;
  startDate: string;
  status: string;
  sortBy: string;
  sortOrder: string;
};

export type UpdateLenderBody = {
  address: string;
  bankDetails: {
    accountNumber: string;
    bankHolderName: string;
    bankName: string;
    branchAddress: string;
    branchName: string;
    ifsc: string;
  };
  clientName: string;
  companyName: string;
  email: string;
  mobileNumber: string;
};

export function getAdminCaseDetails(id: string, bucketName: string) {
  const endpoint = `${ADMIN_CASE_DETAILS_ENDPOINT}${id}&bucketName=${bucketName}`;
  return axios.get(endpoint);
}

export function getUsers(page: number, size: number) {
  const endpoint = `${ADMIN_GET_USERS_ENDPOINT}?pageNumber=${page}&pageSize=${size}`;
  return axios.get(endpoint);
}

export function getMandatoryFeilds() {
  return axios.get(FETCH_MANDATORY_FIELD_ENDPOINT);
}
export function getMandatoryFeildsT() {
  return axios.get('https://dev.solveesy.com/v1/agent/start?agentEmail=techproduct@solveesy.in');
}

export async function updateMandatoryFields(body: {}) {
  const res = await axios.post(UPDATE_MANDATORY_FIELD_ENDPOINT, body);
  if (res.status === 200) {
    return res.data;
  }
}

export function updateUserDetails(body: UpdateUserDetailsBodyTypes) {
  return axios.put(ADMIN_UPDATE_AGENTS, body);
}

export async function getAdminActiveCases(body: CasesBodyType) {
  const res = await axios.post(ADMIN_ACTIVE_CASES_ENDPOINT, body);
  // const res = await axiosInstance.post(ADMIN_ACTIVE_CASES_ENDPOINT, body);
  if (res.status === 200) {
    return res.data;
  }
}

export async function getAdminPendingCases() {
  const res = await axios.get(ADMIN_PENDING_CASES_ENDPOINT);
  if (res.status === 200) {
    return res.data;
  }
}

export async function transferCaseToLegal(caseId: string) {
  const endpoint = `${ADMIN_TRANSFER_TO_LEGAL}${caseId}`;
  const res = await axios.get(endpoint);
  if (res.status === 200) {
    return res.data;
  }
}

export async function getAdminCompletedCases(body: CasesBodyType) {
  const res = await axios.post(ADMIN_COMPLETED_CASES_ENDPOINT, body);
  if (res.status === 200) {
    return res.data;
  }
}

export function getManagers() {
  return axios.get(ADMIN_MANAGERS_LIST_ENDPOINT);
}

export async function getLenders(page: number) {
  const endpoint = `${ADMIN_LENDERS_LIST_ENDPOINT}${page}`;
  const res = await axios.get(endpoint);
  return res.data;
}

export async function getAllRoles() {
  const res = await axios.get(ADMIN_ROLES_LIST_ENPOINT);
  if (res.status === 200) {
    return res.data;
  }
}

export async function getPhonebooks(page: number) {
  const endpoint = `${FETCH_PHONEBOOKS}${page}`;
  const res = await axios.get(endpoint);
  if (res.status === 200) {
    return res.data;
  }
}

export async function getSamplePhonebook() {
  const res = await axios.get(FETCH_SAMPLE_PHONEBOOK);
  if (res.status === 200) {
    return res.data;
  }
}

export async function getPreIntSamplePhonebook() {
  const res = await axios.get(FETCH_SAMPLE_PREINTERVENTION);
  if (res.status === 200) {
    return res.data;
  }
}

export async function getSummaryPreIntervention(lenderId:String) {
  const res = await axios.get(`${PRE_INTERVENTION_SUMMARY}?clientId=${lenderId}`);
  if (res.status === 200) {
    return res.data;
  }
}

export const fetchAnalysisData = async ({ queryKey }: any) => {
  const [_key, { clientId, stage, status }] = queryKey;
  const response = await axios.post(PRE_INTERVENTION_TABLE, {
    clientId,
    stage,
    status,
  });
  return response.data.data;
};
export async function createPhonebook(body: any) {
  const res = await axios.post(POST_CREATE_PHONEBOOK, body);
  if (res.status === 200) {
    return res.data;
  }
}

export function createUser(body: any) {
  return axios.post(ADMIN_CREATE_USER_ENDPOINT, body);
}

export function updateUserStatus(body: {
  email: string | "";
  enable: false | true;
}) {
  return axios.put(ADMIN_UPDATE_USER_STATUS_ENDPOINT, body);
}

export function createClient(body: any) {
  return axios.post(CREATE_CLIENT_ENDPOINT, body);
}

export function editLender(clientId: string, body: UpdateLenderBody) {
  const endpoint = `${UPDATE_LENDER_ENDPOINT}${clientId}`;
  return axios.put(endpoint, body);
}